import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export default function MembersSubscriber() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/portal");
  }, [navigate]);

  return null;
}
